// extracted by mini-css-extract-plugin
module.exports = {"ReplyButton":"pc_a bhc_vr bhc_iv bhc_wf bhc_i bhc_j bhc_q bhc_un bhc_en bhc_ri bhc_rj bhc_cx","ReplyButton__icon":"pc_b bhc_re"};